var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfillment-detail-card"},[_c('p',{staticClass:"fulfillment-detail-card_title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"flex items-start gap-[10px]"},[_c('span',[_vm._v(":")]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }